import { withLogs } from '@core';

import { apiClient, ApiConfig } from '../apiClient';

export type VideoMetadata = {
    totalFrames: number;
    sourceFps: number;
    sourceWidth: number;
    sourceHeight: number;
    frontendFps: number;
    frontendWidth: number;
    frontendHeight: number;
};
export type VideoPayload = {
    url: string;
    cameraName: string;
    cameraId: string;
    view: number;
    metadata: VideoMetadata;
};

type SwingVideosResponse = {
    videos: VideoPayload[];
};

export const fetchSwingVideos = withLogs(async (swingUUID: string) => {
    const { data } = await apiClient.get<SwingVideosResponse>(ApiConfig.path(`api/v1/swings/${swingUUID}/videos`));
    return data.videos;
}, 'fetchSwingVideos');
